<pagination>
    <div class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
        <div class="flex flex-1 justify-between sm:hidden">
            <span class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" onclick="{
                        previous
                    }">Precedente</span>
            <span class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" onclick="{
                        next
                    }">Successiva</span>
        </div>
        <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            <div>
                <p class="text-sm text-gray-700">
                    Visualizza da
                    <span class="font-medium">{ (props.page_size * (state.current_page - 1) + 1) }</span>
                    a
                    <span class="font-medium">{ ((props.page_size * state.current_page) < props.total_rows ? (props.page_size * state.current_page) : props.total_rows) }</span>
                    di
                    <span class="font-medium">{ props.total_rows }</span>
                    risultati
                </p>
            </div>
            <div>
                <nav class="isolate inline-flex -space-x-px rounded-md shadow-xs" aria-label="Pagination">
                    <span class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" onclick="{
                                previous
                            }">
                        <span class="sr-only">Precedente</span>
                        <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd" d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd" />
                        </svg>
                    </span>
                    <span each="{ i in state.pages_to_show }" class="relative inline-flex items-center px-4 py-2 text-sm font-semibold { state.current_page === i ? 'z-10 bg-cyan-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600' : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0' }" onclick="{
                                changePage.bind(this, i)
                            }">{ i }</span>
                    <span class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0" onclick="{
                                next
                            }">
                        <span class="sr-only">Successiva</span>
                        <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                        </svg>
                    </span>
                </nav>
            </div>
        </div>
    </div>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS, CONFIG } from '/src/utils/constants'

        export default {

            onBeforeMount(props, state) {

                this.state = {
                    total_pages: 0,
                    pages_to_show: [1],
                    current_page: props.current_page
                }

                eventBus.on(EVENTS.ITEMS.CHANGED, this.handlePaginationItemsChanged)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.ITEMS.CHANGED, this.handlePaginationItemsChanged)
            },

            previous() {
                if (this.state.current_page > 1) {
                    this.changePage(this.state.current_page - 1)
                }
            },

            next() {
                const totalPages = Math.ceil(this.props.total_rows / this.props.page_size)
                if (this.state.current_page < totalPages) {
                    this.changePage(this.state.current_page + 1)
                }
            },

            changePage(p) {
                if (!isNaN(p)) {
                    eventBus.trigger(EVENTS.UI.CHANGE_PAGE, {
                        ckey: this.props.ckey,
                        page: p
                    })
                }
            },

            updatePagesToShow(total_rows, currentPage) {
                const totalPages = Math.ceil(total_rows / this.props.page_size)
                let pagesToShow = [];

                if (totalPages <= 1) {
                    // Se c'è solo una pagina, mostriamo solo quella
                    pagesToShow = [1];
                } else {
                    // Aggiungi sempre la prima pagina
                    pagesToShow.push(1);

                    if (currentPage > 2) {
                        // Aggiungi puntini se necessario
                        pagesToShow.push('...');
                    }

                    if (currentPage > 1 && currentPage < totalPages) {
                        // Mostra la pagina corrente solo se non è la prima o l'ultima
                        pagesToShow.push(currentPage);
                    }

                    if (currentPage < totalPages - 1) {
                        // Aggiungi puntini se necessario
                        pagesToShow.push('...');
                    }

                    // Aggiungi sempre l'ultima pagina
                    pagesToShow.push(totalPages);
                }

                this.update({
                    total_pages: totalPages,
                    pages_to_show: pagesToShow,
                    current_page: currentPage
                })
                return pagesToShow;
            },

            handlePaginationItemsChanged(e) {
                if (e.ckey === this.props.ckey) {
                    this.updatePagesToShow(e.items.count, e.page)
                }
            }
        }
    </script>
</pagination>
